package tta.destinigo.talktoastro.feature_call_consultation.domain

import kotlinx.serialization.json.JsonElement
import tta.destinigo.talktoastro.shared.remote.PusherSocket

class SocketRepository(
    private val socket: PusherSocket
) {
    fun connect(onConnected: (String) -> Unit, onError: (String) -> Unit) {
        socket.setOnConnected(onConnected)
        socket.setOnError(onError)
        socket.connect()
    }

    suspend fun subscribe(channel: String, token: String? = null) {
        socket.subscribe(channel, token)
    }

    suspend fun unsubscribe(channel: String) {
        socket.unsubscribe(channel)
    }

    suspend fun disconnect() {
        socket.disconnect()
    }

    fun observeMessages(
        onMessage: (String, JsonElement) -> Unit,
        onSubscribed: (String) -> Unit,
        onDisconnected: () -> Unit
    ) {
        socket.setOnMessageReceived(onMessage)
        socket.setOnChannelSubscribed(onSubscribed)
        socket.setOnDisconnected(onDisconnected)
    }
}